<template>
  <layout-form>
    <input-password />
    <input-confirm />
  </layout-form>
</template>

<script>
import LayoutForm from '@/lib//Layout/Form'

import InputPassword from './InputPassword'
import InputConfirm from './InputConfirm'

export default {
  components: {
    LayoutForm,
    InputPassword,
    InputConfirm
  }
}
</script>
